import formatNumber from './formatNumber'

export default function formatCurrency(value, decimals = 0) {
  return formatNumber(value, { format: 'currency', decimals })
}
